import { useNavigate } from "react-router-dom";
import { useUserPoints } from "@/hooks/useUserPoints";

export default function PointsBadge() {
  const { balance, loading } = useUserPoints();
  const navigate = useNavigate();
  if (loading) return null;
  return (
    <button
      type="button"
      onClick={() => navigate("/billing")}
      className="inline-flex items-center justify-center gap-1 rounded-full bg-muted px-2.5 py-1 text-xs font-medium text-muted-foreground hover:bg-accent hover:text-foreground transition-colors min-h-[44px] min-w-[44px]"
      title={`${balance} mérite${balance > 1 ? "s" : ""}`}
    >
      <span className="text-[11px]">⚡</span>
      {balance}
    </button>
  );
}
